'use strict'

var App = require('app')

/* Views */
var Show = require('./show')

var DeviceEvents = function () {
    /* Routes ----------------------------------------------------------------- */
    /* API -------------------------------------------------------------------- */
  var API = {
    show: function (options) {
      let show = new Show(options)
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('device-events:show', function (options) {
    API.show(options)
  })
}

module.exports = DeviceEvents



// WEBPACK FOOTER //
// ./js/modules/device-events/index.js